import React from "react"

import "./hubspotForm.scss"

class HubspotForm extends React.Component {
  componentDidMount() {
  	const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/shell.js';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
    	if(window.hbspt) {
      	window.hbspt.forms.create({
        	portalId: '8255449',
          formId: '6ed2c52b-050c-4fdc-ada1-71a09eb5e82c',
          target: '#hubspotForm'
        })
      }
    });
  }
  
	render() {
  	return (
  		<div className="hubspotForm-wrapper" >
        <h2>Iratkozzon fel hírlevelünkre!</h2>
  		  <div id="hubspotForm"></div>
  		</div>
    );
  }
}

export default HubspotForm